"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCTAButtonPadding = void 0;
var defaultCTAButtonPadding = {
    desktop: '20px 40px',
    tablet: '20px 40px',
    mobile: '15px'
};
exports.defaultCTAButtonPadding = defaultCTAButtonPadding;
//# sourceMappingURL=CTAButton.js.map